// components/CategoryManagement/CategoryDetailModal.jsx
import React from 'react';
import Button from "../Button";
import { toPersianNumbers } from "../../utils/toPersianNumbers";

const CategoryDetailModal = ({ categoryDetail, onClose, onEdit }) => {
  if (!categoryDetail) return null;

  const attributes = categoryDetail.attributes || [];

  return (
    <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center p-4 z-50">
      <div className="bg-white rounded-xl shadow-2xl w-full max-w-4xl max-h-[90vh] overflow-y-auto">

        {/* Header */}
        <div className="flex items-center justify-between px-6 py-4 border-b">
          <h3 className="text-lg font-semibold text-[#1E3A5F]">
            جزئیات دسته: {categoryDetail.name}
          </h3>
          <div className="flex items-center gap-3">
            <Button variant="primary" onClick={() => onEdit(categoryDetail)}>
              ویرایش
            </Button>
            <Button variant="secondary" onClick={onClose}>
              بستن
            </Button>
          </div>
        </div>

        {/* Content */}
        <div className="p-6 space-y-8">

          {/* Top section */}
          <div className="grid grid-cols-12 gap-6 items-start">

            {/* Image */}
            <div className="col-span-4">
              <div className="w-full aspect-square rounded-lg overflow-hidden border bg-gray-50 flex items-center justify-center">
                {categoryDetail.category_image ? (
                  <img
                    src={categoryDetail.category_image}
                    alt={categoryDetail.name}
                    className="w-full h-full object-cover"
                  />
                ) : (
                  <span className="text-sm text-gray-400">بدون تصویر</span>
                )}
              </div>
            </div>

            {/* Main info */}
            <div className="col-span-8 space-y-4">
              <InfoRow label="کد دسته" value={toPersianNumbers(categoryDetail.code)} />
              <InfoRow label="اسلاگ" value={categoryDetail.slug} />
              <InfoRow
                label="والد"
                value={categoryDetail.full_path || 'دسته سطح اول'}
              />
            </div>
          </div>

          {/* Description */}
          <div className="space-y-2">
            <div className="text-sm text-[#2B5388]">توضیحات</div>
            <div className="bg-[#F9FAFB] border rounded-lg p-4 text-[#1E3A5F] text-sm leading-relaxed">
              {categoryDetail.description || 'بدون توضیحات'}
            </div>
          </div>

          {/* Attributes */}
          <div className="space-y-4">
            <h4 className="text-sm font-medium text-[#2B5388]">
              مشخصه‌ها
            </h4>

            {attributes.length === 0 ? (
              <div className="text-sm text-[#1E3A5F]">
                این دسته مشخصه‌ای ندارد.
              </div>
            ) : (
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                {attributes.map((ca, index) => (
                  <div
                    key={ca.id}
                    className="border rounded-lg p-4 bg-[#F5F5F5] space-y-3"
                  >
                    <div className="flex items-center justify-between">
                      <div className="font-medium text-[#1E3A5F]">
                        {toPersianNumbers(index + 1)}. {ca.attribute?.name}
                      </div>
                      {ca.attribute?.unit && (
                        <span className="text-xs text-gray-500">
                          {ca.attribute.unit}
                        </span>
                      )}
                    </div>

                    {ca.attribute?.predefined_values?.length > 0 && (
                      <div className="flex flex-wrap gap-2">
                        {ca.attribute.predefined_values.map((v, i) => (
                          <span
                            key={v.id}
                            className="px-3 py-1 text-sm rounded border bg-[#E5E5E5]"
                          >
                            {toPersianNumbers(i + 1)}- {v.value}
                          </span>
                        ))}
                      </div>
                    )}
                  </div>
                ))}
              </div>
            )}
          </div>

        </div>
      </div>
    </div>
  );
};

const InfoRow = ({ label, value }) => (
  <div className="flex flex-col gap-1">
    <div className="text-sm text-[#2B5388]">{label}</div>
    <div className="text-base text-[#1E3A5F]">{value}</div>
  </div>
);

export default CategoryDetailModal;
